<!-- 非标商品添加图片 -->
<template>
  <div>
    <div class="contents">
      <div class="img-choice">
        <p>
          点击“上传图片”进行本地图片上传，1至5张图片，支持JPG、JPEG、PNG格式，建议宽度为800px的图片，单张大小不超过4M。
        </p>
      </div>
      <!-- 主图 -->
      <div class="img-local">
        <div class="choice-img-wrap">
          <draggable
            :list="mainImgList"
            :disabled="!enabled"
            class="list-group"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="dragging = false"
          >
            <div
              v-for="(item, index) in mainImgList"
              :key="index"
              class="images"
            >
              <template>
                <img
                  class="show-img"
                  v-viewer="{ toolbar: false, zIndex: 9999 }"
                  :src="item.url"
                  alt
                />
                <img
                  class="icon-close pointer"
                  src="../../../../../assets/img/product/icon-draggable@2x.png"
                  alt
                  style="left: 20px"
                />
                <img
                  class="icon-close pointer"
                  src="../../../../../assets/img/product/icon-preview@2x.png"
                  alt
                  style="left: 40px"
                  @click="show(item.url)"
                />
                <img
                  class="icon-close pointer"
                  src="../../../../../assets/img/product/icon-delete.png"
                  alt
                  style="left: 60px"
                  @click="deleteImgList(item)"
                />
                <div v-if="index == 0" class="main-img-icon-wrap">
                  <img
                    class="icon-main"
                    src="../../../../../assets/img/product/offstandard-product-icon@2x.png"
                    alt
                  />
                  <!-- <span>商品主图</span> -->
                </div>

                <div class="mask"></div>
              </template>
              <!-- </viewer> -->
            </div>
          </draggable>
        </div>
        <div v-if="mainImgList.length < 5" class="img-item">
          <el-upload
            ref="mainImg"
            :action="uploadUrl"
            :on-success="handleImgSuccess"
            accept=".jpg, .png, .pdf, .jpeg"
            :before-upload="beforeUpload"
            :headers="headers"
            :file-list="fileList"
            :on-remove="handleImgRemove"
            :show-file-list="false"
            :on-error="handleImgError"
            multiple
            :limit="mainImgLimit"
            :on-exceed="handleImgExceed"
          >
            <div class="upload-btn">
              <eui-icon icon="eicon-add" color="#2587FF" font-size="20px" />

              <div class="txt">上传图片</div>
            </div>
          </el-upload>
        </div>
        <!-- <span class="upload-txt">本地上传({{ mainImgList.length }}/5)</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { epecToken } from '../../../utils/globalData';
import api from '../../../api/product/index.js';
import productUtils from '../../../utils/productUtils.js';
import util from '../../../utils/utils';
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import Vue from 'vue';
import draggable from 'vuedraggable';

Vue.use(VueViewer);
VueViewer.setDefaults({
  toolbar: false,
  zIndex: 9999,
});
export default {
  props: {
    showFileList: {
      //编辑回显图片
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      node: {},
      imgType: 0, // 0为主图，1为详情图
      showBtn: true,
      defaultImgList: [1, 2, 3, 4], // 图片默认占位图
      uploadUrl: api.fileUpload,
      headers: epecToken,
      fileList: [],
      mainImgLimit: 5, // 主图默认上传限制

      imgList: [], // 图片链接
      mainImgList: JSON.parse(JSON.stringify(this.showFileList)),
      enabled: true,
    };
  },

  components: { draggable },

  computed: {
    // mainImgList() {
    //   return this.showFileList.length > 0 ? this.showFileList : [];
    // },
  },

  created() {
    console.log('子组件');
    console.log(this.showFileList);
    // if (this.showFileList.length > 0) {
    //   this.mainImgList = this.showFileList;
    // }
  },
  methods: {
    async initData() {
      this.showBtn = true;
      this.imgType = 0;
      this.imgList = [];
      this.defaultImgList = [];
      this.defaultDetailImgList = [];
      // console.log('===========', this.detailImgList);
      // console.log('===========', this.mainImgList);
      for (let i = this.mainImgList.length; i < 4; i++) {
        this.defaultImgList.push(i + 1);
      }
      for (let i = this.detailImgList.length; i < 9; i++) {
        this.defaultDetailImgList.push(i + 1);
      }

      const params = {
        fileType: this.imgType,
        parentId: -1,
      };
      console.log(this.defaultImgList);
      console.log(this.defaultDetailImgList);
    },

    Cancel() {
      if (this.$refs.mainImg !== undefined) {
        this.$refs.mainImg.clearFiles();
      }
      if (this.$refs.detailImg !== undefined) {
        this.$refs.detailImg.clearFiles();
      }
      // this.fileList.length = 0;
      // this.mainImgList.length = 0;
      // this.detailFileList.length = 0;
      // this.imageUrlsExist.length = 0;
      // this.detailImageUrlsExist.length = 0;
      (this.defaultImgList = [1, 2, 3, 4]), // 图片默认占位图
        (this.defaultDetailImgList = [1, 2, 3, 4, 5, 6, 7, 8, 9]), // 详情图默认占位图
        console.log(this.fileList);
      console.log(this.mainImgList);
      this.$emit('handleCancel');
    },
    show(img) {
      console.log(img);
      this.$viewerApi({
        images: [img],
      });
    },
    checkMove(e) {
      console.log(`Future index: ${e.draggedContext.futureIndex}`);
    },
    // 删除图片
    deleteImgList(item) {
      const index = productUtils.getIndexInArr(
        this.mainImgList,
        'url',
        item.url
      );
      this.mainImgList.splice(index, 1);
      this.handleImgRemove();
      this.$emit('getImgList', this.mainImgList);
      console.log(this.mainImgList);
      console.log(this.fileList);
    },
    handleImgSuccess(res, file) {
      console.log(res);
      console.log(file);
      // this.fileList.push(res.data.url);
      // this.showFileList.push({
      //   url: res.data.url,
      //   // type: 'upload',
      // });
      this.mainImgList.push({
        url: res.data.url,
        // type: 'upload',
      });
      console.log(this.mainImgList);
      this.$emit('getImgList', this.mainImgList);
    },
    beforeUpload(file) {
      console.log(file);
      if (
        file.type != 'image/png' &&
        file.type != 'image/jpg' &&
        file.type != 'image/jpeg'
      ) {
        this.$message.warning('文件为JPG、JPEG、PNG格式');
        return false;
      }
      const size = file.size / 1024 / 1024;
      if (size > 4) {
        this.$message.warning('图片不能超过4M');
        return false;
      }

      const { length } = this.mainImgList;
      if (length >= 5) {
        this.$message.warning('主图的图片数量不能超过5张');
        return false;
      }
    },
    handleImgRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleImgError(err) {
      console.log(err);
      this.$router.push({ path: '/ssologin' });
    },
    handleImgExceed(files) {
      const total = files.length + this.mainImgList.length;
      if (total > 5) {
        this.$message.warning(`主图的图片数量不能超过5张`);
      }
    },
    clearImg() {
      this.mainImgList = [];
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
@import '@/assets/css/theme.scss';

.contents {
  // min-height: 500px;
  width: auto;

  box-sizing: border-box;
  .img-choice {
    font-size: 12px;
    color: #999;
  }
  .img-store-wrap {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    border-bottom: 1px solid #d9d9d9;
  }
  .img-ope {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    // margin-top: 20px;
    width: 186px;
    .ope {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      .img-tree {
        // position: absolute;
        // top: 34px;
        // left: 0px;
        // z-index: 1000;
        border: 1px solid #ddd;
        width: 100%;
        height: 300px;
        background: #fff;
        overflow-y: auto;
      }
      .img-tree-wrap {
        border: 1px solid #d9d9d9;
        width: 187px;
        height: 30px;
        display: inline-block;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #333;
        padding-left: 10px;
        cursor: pointer;
      }
    }
  }
  .img-list {
    margin-top: 20px;
    height: 320px;
    overflow-y: auto;
    width: 560px;
    display: flex;
    margin-left: 20px;
    flex-wrap: wrap;
    // border-bottom: 1px solid #d9d9d9;
    // &:after {
    //   display: inline-block;
    //   width: 100%;
    //   content: "";
    // }
    div {
      position: relative;
      &:not(:nth-child(5n)) {
        margin-right: 10px;
      }
    }
    img {
      width: 100px;
      height: 100px;
      cursor: pointer;
      // margin-right: 10px;
    }
    span {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 2px solid #c5c5c5;
      position: absolute;
      top: 4px;
      right: 14px;
      color: #fff;
      font-weight: 800;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        background: $main-col;
        border: 1px solid $main-col;
      }
    }
  }
  .choice-img-wrap {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    &.detail-img-wrap {
      overflow-x: scroll;
      width: 100%;
      height: 115px;
    }
    & > div {
      display: flex;
      position: relative;
      // margin-left: 10px;
    }
    img {
      width: 100px;
      height: 100px;
    }
    .icon-close {
      position: absolute;
      // right: 6px;
      // top: 6px;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    .default-img-wrap {
      position: absolute;
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #d9d9d9;
      // margin-left: 20px;
      img {
        width: 40px;
        height: 28px;
      }
    }
    .images {
      background: #fff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      height: 100px;

      .show-img {
        border: 1px solid #d9d9d9;
      }
      .icon-close {
        display: none;
      }
      .mask {
        width: 100px;
        height: 100px;
        position: absolute;
        z-index: 1;
        background: rgba(0, 0, 0, 0.5);
        display: none;
      }
      &:hover {
        // background: rgba(0, 0, 0, 0.5);
        //  width: 100px;
        //  height: 100px;
        //  position: absolute;
        //  z-index: 1000;
        .mask {
          display: inline-block;
        }
        .icon-close {
          display: inline-block;
          width: 16px;
          height: 16px;
          position: absolute;
          z-index: 2;
        }
      }
      .main-img-icon-wrap {
        position: absolute;
        width: 100px;
        height: 20px;
        left: 0px;
        top: 0px;
        // background: rgba(0, 0, 0, 0.5);
        display: flex;
        // justify-content: center;
        // align-items: center;
        .icon-main {
          width: 22px;
          height: 22px;
          // margin-right: 4px;
        }
        span {
          font-size: 14px;
          color: #fff;
        }
      }
    }
  }
  .img-local {
    display: flex;
    .img-item {
      display: flex;
      flex-flow: column;
      .txt {
        line-height: 10px;
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }
    }
    .upload-txt {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
    .upload-btn {
      width: 100px;
      height: 100px;
      border: 1px dashed #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      font-size: 10px;
      img {
        width: 36px;
        height: 36px;
      }
    }
  }
  .btn-wrap {
    text-align: center;
    margin-top: 10px;
  }
}
</style>
